import { useCohortBuilderData } from '@verantos-dev/data-access-cohorts';

import { usePrefetchCohortData } from './usePrefetchCohortData';
import { usePrefetchResultsData } from './usePrefetchResultsData';

export const useCohortBuilderPagePreFetch = () => {
  const { projectId, cohortId, cohortVersionId } = useCohortBuilderData();

  const { cohortData } = usePrefetchCohortData(projectId, cohortId, cohortVersionId);
  const { isFinalFetchTimerActive } = usePrefetchResultsData(
    projectId,
    cohortId,
    cohortData?.data.latestStatus
  );

  return { isFinalFetchTimerActive };
};
